import { render, staticRenderFns } from "./ProductionAnalisysMonthChart.vue?vue&type=template&id=67ac2b54&scoped=true&"
import script from "./ProductionAnalisysMonthChart.vue?vue&type=script&lang=js&"
export * from "./ProductionAnalisysMonthChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67ac2b54",
  null
  
)

export default component.exports